import React from 'react';
import { Link } from '@reach/router';
import { SubjectSiteLink } from './subjectSiteMenu';

type Props = Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, 'href'> & {
  link: SubjectSiteLink;
  children?: React.ReactNode;
};

/**
 * A subject site link: a route of this app, or a page elsewhere
 */
const SubjectSiteMenuLink: React.FC<Props> = ({
  link,
  children,
  ...anchorProps
}) => {
  const content = children ?? (link.bBold ? <b>{link.name}</b> : link.name);

  return link.bInApp ? (
    <Link to={link.url} {...anchorProps}>
      {content}
    </Link>
  ) : (
    <a href={link.url} {...anchorProps}>
      {content}
    </a>
  );
};

export default SubjectSiteMenuLink;
